import _asyncToGenerator from "/workdir/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _regeneratorRuntime from "/workdir/node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js";
import createInfiniteQueryHook from '@segment/utils/createInfinityQueryHook';
import { fetchResources } from '../../../algolia/resources';
import { useResourcesIndex } from '../contexts/algoliaClientContext';
export var createResourcesQuery = function createResourcesQuery(searchIndex, _ref) {
  var query = _ref.query,
      hitsPerPage = _ref.hitsPerPage,
      filters = _ref.filters;
  return [["resources", "resourcesQuery", query, hitsPerPage, filters], /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(_ref2) {
      var pageParam;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              pageParam = _ref2.pageParam;
              return _context.abrupt("return", fetchResources({
                searchIndex: searchIndex,
                page: pageParam,
                query: query,
                filters: filters,
                hitsPerPage: 6
              }));

            case 2:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function (_x) {
      return _ref3.apply(this, arguments);
    };
  }()];
};
export var useResourcesQuery = createInfiniteQueryHook(createResourcesQuery, useResourcesIndex, {
  staleTime: Infinity,
  getPreviousPageParam: function getPreviousPageParam(_ref4) {
    var _ref4$page = _ref4.page,
        page = _ref4$page === void 0 ? 0 : _ref4$page;
    var prevPage = page - 1;

    if (prevPage < 0) {
      return;
    }

    return prevPage;
  },
  getNextPageParam: function getNextPageParam(_ref5) {
    var _ref5$page = _ref5.page,
        page = _ref5$page === void 0 ? 0 : _ref5$page,
        nbPages = _ref5.nbPages;
    var nextPage = page + 1;

    if (nextPage >= nbPages) {
      return;
    }

    return nextPage;
  }
});